<template>
  <div>
    <Head :title="form.country_name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/bizneset">Bizneset / </Link>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.businesses.edit', {business: this.business.id})">{{ business.name }} /</Link>
      <span class="text-indigo-400 font-medium"> Çmimet / </span>
<!--      <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.users.sellers.edit', {seller: this.seller.id})">Çmimet /</Link>-->
      {{pricing.country_name}} - {{pricing.package_size_name}}

    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.country_name" :error="form.errors.country_name" :disabled="true" class="pb-8 pr-6 w-full lg:w-1/2" label="Shteti" />
          <text-input v-model="form.package_size_name" :error="form.errors.package_size_name" :disabled="true" class="pb-8 pr-6 w-full lg:w-1/2" label="Madhësia" />
          <text-input v-model="form.shipping_price" :error="form.errors.shipping_price"  class="pb-8 pr-6 w-full lg:w-1/2" label="Çmimi i transportit" />
          <text-input v-model="form.cancellation_price" :error="form.errors.cancellation_price"  class="pb-8 pr-6 w-full lg:w-1/2" label="Çmimi i anulimit" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Edito</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Pagination
  },
  layout: Layout,
  props: {
    pricing: Object,
    business: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        country_name: this.pricing.country_name,
        package_size_name: this.pricing.package_size_name,
        shipping_price: this.pricing.shipping_price,
        cancellation_price: this.pricing.cancellation_price,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/admin/bizneset/${this.business.id}/cmimet/${this.pricing.id}`)
    },
  },
}
</script>
